import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import ChangePasswordModal from '../modal/ChangePasswordModal';
//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';
import { FaSubscript } from 'react-icons/fa';
import getPermissionList from '../../slices/veloxity/auth/permissionsManagement/getPermissionList';
// Add this constant at the top of the file, before the ProfileDropdown component
// Add this helper function
const getClientName = (clientId) => {
    return CLIENT_MAPPING[clientId] || 'Unknown Client';
};

const ProfileDropdown = () => {
    const storedUserData = sessionStorage.getItem("authUserData");
    const userData = storedUserData ? JSON.parse(storedUserData) : null;
    const profiledropdownData = createSelector(
        (state) => state.Profile.user,
        (user) => user
      );
    // Inside your component
    const user = useSelector(profiledropdownData);
    const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] = useState(false);
    const isAdmin = userData.type === "ADMIN";
    const [userName, setUserName] = useState("Admin");
    const [userType, setUserType] = useState("");
    const [clientID, setClientID] = useState("");
    const companyName = useSelector(state => state.getPermissionsList.subscriptions?.[0]?.companyName) || "Company Name";

    
    useEffect(() => {
        if (sessionStorage.getItem("authUser")) {
            const obj = JSON.parse(sessionStorage.getItem("authUser"));
            setUserName(obj.data.user.name + " " + obj.data.user.surname);
            setUserType(obj.data.user.type || "UserType");
            setClientID(obj.data.user.clientId || "clientID");
        }
    }, [userName, user]);
    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    const toggleChangePasswordModal = () => {
        setIsChangePasswordModalOpen(!isChangePasswordModalOpen);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={avatar1}
                            alt="Header Avatar" />
                        <span className="text-start ms-xl-2">
                            <div className="d-flex flex-column">
                                <span className="d-none d-xl-inline-block fw-medium user-name-text">{userName}</span>
                                <span className="d-none d-xl-block fs-12 text-muted user-name-sub-text">{userType}</span>
                                <span className="d-none d-xl-block fs-12 text-muted user-name-sub-text">{companyName}</span>
                            </div>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                {
                    /*
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/profile"} className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                 <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/pages-faqs"} className="dropdown-item">
                            <i
                                className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Help</span>
                        </Link>
                    </DropdownItem>
                    * */
                }
                    <div className="dropdown-divider"></div>
                    {
                        /*
                         <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/pages-profile-settings"} className="dropdown-item">
                            <span
                                className="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                                    className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                        className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem>
                        * */
                    }
                    <DropdownItem className='p-0' onClick={toggleChangePasswordModal}>
                        <span className="dropdown-item">
                            <i className="mdi mdi-lock-reset text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Change Password</span>
                        </span>
                    </DropdownItem>
                    {isAdmin && (
                        <DropdownItem className='p-0'>
                            <Link to={process.env.PUBLIC_URL + "/company-admin"} className="dropdown-item">
                                <i className="mdi mdi-account-cog text-muted fs-16 align-middle me-1"></i>
                                <span className="align-middle" data-key="t-logout">Admin</span>
                            </Link>
                        </DropdownItem>
                    )}
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/logout"} className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <ChangePasswordModal isOpen={isChangePasswordModalOpen} toggle={toggleChangePasswordModal} />
        </React.Fragment>
    );
};
export default ProfileDropdown;